module.exports = __webpack_public_path__ + "img/issues-buttons-add.96407299.svg";